export default __webpack_public_path__ + "static/media/programming.38dce580.jpeg";